import React, { useEffect, useState } from 'react';

interface BeforeInstallPromptEvent extends Event {
  prompt: () => Promise<void>;
  userChoice: Promise<{ outcome: 'accepted' | 'dismissed' }>;
}

const InstallPrompt: React.FC = () => {
  const [deferredPrompt, setDeferredPrompt] = useState<BeforeInstallPromptEvent | null>(null);
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    // すでにインストール済みなら非表示
    if (window.matchMedia('(display-mode: standalone)').matches) return;

    const handler = (e: Event) => {
      e.preventDefault();
      setDeferredPrompt(e as BeforeInstallPromptEvent);
      setShowBanner(true);
    };

    window.addEventListener('beforeinstallprompt', handler);
    return () => window.removeEventListener('beforeinstallprompt', handler);
  }, []);

  const handleInstall = async () => {
    if (!deferredPrompt) return;
    await deferredPrompt.prompt();
    const { outcome } = await deferredPrompt.userChoice;
    if (outcome === 'accepted') setShowBanner(false);
    setDeferredPrompt(null);
  };

  const handleDismiss = () => setShowBanner(false);

  if (!showBanner) return null;

  return (
    <div style={{
      position: 'fixed', top: 0, left: 0, right: 0, zIndex: 9999,
      background: 'linear-gradient(135deg, #d97706, #92400e)',
      color: 'white', padding: '10px 16px',
      display: 'flex', alignItems: 'center', justifyContent: 'space-between',
      boxShadow: '0 2px 8px rgba(0,0,0,0.3)', fontSize: '14px'
    }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
        <img src="/logo192.png" alt="icon" style={{ width: 36, height: 36, borderRadius: 8 }} />
        <div>
          <div style={{ fontWeight: 'bold', fontSize: '13px' }}>📲 氣ごよみをインストール</div>
          <div style={{ fontSize: '11px', opacity: 0.9 }}>ホーム画面に追加して毎日便利に使えます</div>
        </div>
      </div>
      <div style={{ display: 'flex', gap: '8px' }}>
        <button onClick={handleInstall} style={{
          background: 'white', color: '#d97706', border: 'none',
          borderRadius: '6px', padding: '6px 12px', fontWeight: 'bold',
          fontSize: '12px', cursor: 'pointer'
        }}>追加</button>
        <button onClick={handleDismiss} style={{
          background: 'transparent', color: 'white', border: '1px solid rgba(255,255,255,0.5)',
          borderRadius: '6px', padding: '6px 10px', fontSize: '12px', cursor: 'pointer'
        }}>✕</button>
      </div>
    </div>
  );
};

export default InstallPrompt;
